<template>
  <div>
    <div class="card-top">
      <div>
        <i class="el-icon-s-grid mr-4" />
        <span>Chunk-{{get(item, 'metadata.segment_position')}}</span>
        <span class="ml-8 mr-8">·</span>
        <span>{{ get(item, 'metadata.segment_word_count') }}字符</span>
      </div>
      <div class="score">
        SCORE<span class="score-text">{{round(get(item, 'metadata.score') || 0, 2)}}</span>
        <div class="score-inner" :style="{width: (get(item, 'metadata.score') || 0) * 100 + '%' }" />
      </div>
    </div>
    <!-- eslint-disable -->
    <div class="content" :class="{fold}">{{ item.content || '' }}</div>
    <!-- eslint-disable -->
  </div>
</template>

<script>
import {round, get} from 'lodash';
export default {
  props: {
    item: {
      type: Object,
      default: ()=>({}),
    },
    fold: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    round,
    get,
  },
};
</script>

<style lang="scss" scoped>
.card-top {
  display: flex;
  color: var(--Text-Neutral-subtle);
  justify-content: space-between;
  .score {
    width: 80px;
    height: 16px;
    border-radius: 8px;
    border: 1px solid var(--Border-Neutral-subtle);
    position: relative;
    overflow: hidden;
    text-align: center;
    font-size: 10px;
    color: var(--Text-Neutral-default);
    .score-text {
      font-weight: 500;
      margin-left: 4px;
      font-size: 12px;
    }
    .score-inner {
      position: absolute;
      left: 0;
      top: 0;
      height: 14px;
      opacity: 0.5;
      background: var(--Bg-Brand-default);
      border-right: var(--Border-Accent-Ongoing-default);
    }
  }
}
.content {
  white-space: pre-wrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  font-weight: 500;
  margin: 16px 0;
  &.fold {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>
